<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <h2 class="my-4">Poc Gráficas</h2>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <apexchart
            type="radialBar"
            height="350"
            :options="chartOptions"
            :series="series"
        />
      </b-col>
    </b-row>






    <!-- Gráfica de Barras Simple -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Ventas Mensuales">
          <div style="height: 300px">
            <BarChart
              :labels="barChartLabels"
              :data="barChartData"
              :label="barChartLabel"
              backgroundColor="#6b20c1"
              title="Ventas 2024"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Gráfica de Barras Horizontal -->
      <b-col cols="12" lg="6">
        <b-card title="Cursos por Categoría">
          <div style="height: 300px">
            <BarChart
              :labels="['Matemáticas', 'Ciencias', 'Historia', 'Arte']"
              :data="[12, 19, 8, 15]"
              label="Cursos"
              :horizontal="true"
              backgroundColor="#ff5e20"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Gráfica con Múltiples Datasets -->
    <b-row class="mb-4">
      <b-col cols="12">
        <b-card title="Comparación Anual">
          <div style="height: 350px">
            <BarChart
              :labels="['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun']"
              :datasets="multipleBarDatasets"
              title="Ventas 2023 vs 2024"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>



 <!-- Línea Simple -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Usuarios Activos">
          <div style="height: 300px">
            <LineChart
              :labels="lineLabels"
              :data="lineData"
              label="Usuarios"
              borderColor="#6b20c1"
              backgroundColor="rgba(107, 32, 193, 0.1)"
              :fill="true"
              :tension="0.4"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Línea sin relleno -->
      <b-col cols="12" lg="6">
        <b-card title="Progreso Semanal">
          <div style="height: 300px">
            <LineChart
              :labels="['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']"
              :data="[12, 19, 15, 25, 22, 30, 28]"
              label="Cursos completados"
              borderColor="#ff5e20"
              :fill="false"
              :tension="0"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Múltiples líneas -->
    <b-row class="mb-4">
      <b-col cols="12">
        <b-card title="Comparación de Rendimiento">
          <div style="height: 350px">
            <LineChart
              :labels="['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4', 'Sem 5', 'Sem 6']"
              :datasets="multipleLinesDatasets"
              title="Videos vs Actividades"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Línea con estilo personalizado -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Línea Curva Suave">
          <div style="height: 300px">
            <LineChart
              :labels="['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun']"
              :data="[5, 15, 10, 25, 20, 35]"
              label="Ventas"
              borderColor="#28a745"
              backgroundColor="rgba(40, 167, 69, 0.2)"
              :fill="true"
              :tension="0.5"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Línea recta (sin curvatura) -->
      <b-col cols="12" lg="6">
        <b-card title="Línea Recta">
          <div style="height: 300px">
            <LineChart
              :labels="['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun']"
              :data="[5, 15, 10, 25, 20, 35]"
              label="Ventas"
              borderColor="#dc3545"
              :fill="false"
              :tension="0"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>



 <!-- Pastel Simple -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Distribución de Estudiantes">
          <div style="height: 350px">
            <PieChart
              :labels="pieLabels"
              :data="pieData"
              :backgroundColor="['#6b20c1', '#ff5e20', '#ffc107', '#28a745']"
              title="Por Nivel"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Pastel con colores personalizados -->
      <b-col cols="12" lg="6">
        <b-card title="Estado de Cursos">
          <div style="height: 350px">
            <PieChart
              :labels="['Completados', 'En Progreso', 'Pendientes', 'Cancelados']"
              :data="[45, 30, 15, 10]"
              :backgroundColor="['#28a745', '#ffc107', '#17a2b8', '#dc3545']"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Pastel con muchas categorías -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Cursos por Categoría">
          <div style="height: 350px">
            <PieChart
              :labels="['Matemáticas', 'Ciencias', 'Historia', 'Arte', 'Deportes', 'Música']"
              :data="[20, 15, 10, 25, 18, 12]"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Pastel con borde personalizado -->
      <b-col cols="12" lg="6">
        <b-card title="Satisfacción del Cliente">
          <div style="height: 350px">
            <PieChart
              :labels="['Muy Satisfecho', 'Satisfecho', 'Neutral', 'Insatisfecho']"
              :data="[50, 30, 15, 5]"
              :backgroundColor="['#28a745', '#6b20c1', '#ffc107', '#dc3545']"
              :borderColor="['#fff', '#fff', '#fff', '#fff']"
              :borderWidth="3"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Pastel con leyenda en diferentes posiciones -->
    <b-row class="mb-4">
      <b-col cols="12" lg="4">
        <b-card title="Leyenda Arriba">
          <div style="height: 300px">
            <PieChart
              :labels="['A', 'B', 'C']"
              :data="[30, 40, 30]"
              :chart-options="{ plugins: { legend: { position: 'top' } } }"
            />
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" lg="4">
        <b-card title="Leyenda Derecha">
          <div style="height: 300px">
            <PieChart
              :labels="['A', 'B', 'C']"
              :data="[30, 40, 30]"
              :chart-options="{ plugins: { legend: { position: 'right' } } }"
            />
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" lg="4">
        <b-card title="Sin Leyenda">
          <div style="height: 300px">
            <PieChart
              :labels="['A', 'B', 'C']"
              :data="[30, 40, 30]"
              :chart-options="{ plugins: { legend: { display: false } } }"
            />
          </div>
        </b-card>
      </b-col>

</b-row>



 <!-- Dona Simple -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Estado de Cursos">
          <div style="height: 350px">
            <DoughnutChart
              :labels="doughnutLabels"
              :data="doughnutData"
              :backgroundColor="['#28a745', '#ffc107', '#dc3545']"
              cutout="50%"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Dona Delgada (más cutout) -->
      <b-col cols="12" lg="6">
        <b-card title="Progreso General">
          <div style="height: 350px">
            <DoughnutChart
              :labels="['Completado', 'En Progreso', 'Pendiente']"
              :data="[60, 25, 15]"
              :backgroundColor="['#6b20c1', '#ff5e20', '#ffc107']"
              cutout="70%"
              title="70% de grosor"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Dona Gruesa (menos cutout) -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Dona Gruesa">
          <div style="height: 350px">
            <DoughnutChart
              :labels="['A', 'B', 'C', 'D']"
              :data="[25, 25, 25, 25]"
              :backgroundColor="['#6b20c1', '#ff5e20', '#ffc107', '#28a745']"
              cutout="30%"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Dona Ultra Delgada -->
      <b-col cols="12" lg="6">
        <b-card title="Dona Ultra Delgada">
          <div style="height: 350px">
            <DoughnutChart
              :labels="['Opción 1', 'Opción 2', 'Opción 3']"
              :data="[45, 30, 25]"
              :backgroundColor="['#17a2b8', '#28a745', '#ffc107']"
              cutout="85%"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Dona con muchas secciones -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Distribución Detallada">
          <div style="height: 350px">
            <DoughnutChart
              :labels="['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun']"
              :data="[12, 19, 8, 15, 10, 14]"
              cutout="60%"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Dona con borde grueso -->
      <b-col cols="12" lg="6">
        <b-card title="Con Borde Grueso">
          <div style="height: 350px">
            <DoughnutChart
              :labels="['Aprobados', 'Reprobados', 'Pendientes']"
              :data="[70, 15, 15]"
              :backgroundColor="['#28a745', '#dc3545', '#ffc107']"
              :borderWidth="5"
              cutout="55%"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Comparación de grosores -->
    <b-row class="mb-4">
      <b-col cols="12" lg="3">
        <b-card title="30% Cutout">
          <div style="height: 250px">
            <DoughnutChart
              :labels="['A', 'B', 'C']"
              :data="[33, 33, 34]"
              :backgroundColor="['#6b20c1', '#ff5e20', '#ffc107']"
              cutout="30%"
            />
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" lg="3">
        <b-card title="50% Cutout">
          <div style="height: 250px">
            <DoughnutChart
              :labels="['A', 'B', 'C']"
              :data="[33, 33, 34]"
              :backgroundColor="['#6b20c1', '#ff5e20', '#ffc107']"
              cutout="50%"
            />
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" lg="3">
        <b-card title="70% Cutout">
          <div style="height: 250px">
            <DoughnutChart
              :labels="['A', 'B', 'C']"
              :data="[33, 33, 34]"
              :backgroundColor="['#6b20c1', '#ff5e20', '#ffc107']"
              cutout="70%"
            />
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" lg="3">
        <b-card title="85% Cutout">
          <div style="height: 250px">
            <DoughnutChart
              :labels="['A', 'B', 'C']"
              :data="[33, 33, 34]"
              :backgroundColor="['#6b20c1', '#ff5e20', '#ffc107']"
              cutout="85%"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>






  <!-- Área Simple -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Usuarios Activos">
          <div style="height: 300px">
            <AreaChart
              :labels="areaLabels"
              :data="areaData"
              label="Usuarios"
              borderColor="#6b20c1"
              backgroundColor="rgba(107, 32, 193, 0.2)"
              :tension="0.4"
            />
          </div>
        </b-card>
      </b-col>

      <!-- Área con mayor opacidad -->
      <b-col cols="12" lg="6">
        <b-card title="Ventas del Mes">
          <div style="height: 300px">
            <AreaChart
              :labels="['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4']"
              :data="[1200, 1900, 1500, 2200]"
              label="Ventas ($)"
              borderColor="#28a745"
              backgroundColor="rgba(40, 167, 69, 0.4)"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Múltiples Áreas -->
    <b-row class="mb-4">
      <b-col cols="12">
        <b-card title="Comparación de Rendimiento">
          <div style="height: 350px">
            <AreaChart
              :labels="['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4', 'Sem 5', 'Sem 6']"
              :datasets="multipleAreaDatasets"
              title="Videos, Actividades y Exámenes"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Áreas Apiladas (Stacked) -->
    <b-row class="mb-4">
      <b-col cols="12">
        <b-card title="Distribución Acumulada">
          <div style="height: 350px">
            <AreaChart
              :labels="['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun']"
              :datasets="stackedAreaDatasets"
              :chart-options="stackedOptions"
              title="Cursos por Categoría (Apilado)"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Área Suave vs Área Angular -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Área Suave (tension: 0.5)">
          <div style="height: 300px">
            <AreaChart
              :labels="['A', 'B', 'C', 'D', 'E', 'F']"
              :data="[10, 25, 15, 35, 20, 40]"
              label="Datos"
              borderColor="#ff5e20"
              backgroundColor="rgba(255, 94, 32, 0.2)"
              :tension="0.5"
            />
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" lg="6">
        <b-card title="Área Angular (tension: 0)">
          <div style="height: 300px">
            <AreaChart
              :labels="['A', 'B', 'C', 'D', 'E', 'F']"
              :data="[10, 25, 15, 35, 20, 40]"
              label="Datos"
              borderColor="#ff5e20"
              backgroundColor="rgba(255, 94, 32, 0.2)"
              :tension="0"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Área con gradiente visual -->
    <b-row class="mb-4">
      <b-col cols="12" lg="6">
        <b-card title="Opacidad Baja">
          <div style="height: 300px">
            <AreaChart
              :labels="['Lun', 'Mar', 'Mié', 'Jue', 'Vie']"
              :data="[30, 45, 35, 55, 50]"
              label="Visitantes"
              borderColor="#17a2b8"
              backgroundColor="rgba(23, 162, 184, 0.1)"
            />
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" lg="6">
        <b-card title="Opacidad Alta">
          <div style="height: 300px">
            <AreaChart
              :labels="['Lun', 'Mar', 'Mié', 'Jue', 'Vie']"
              :data="[30, 45, 35, 55, 50]"
              label="Visitantes"
              borderColor="#17a2b8"
              backgroundColor="rgba(23, 162, 184, 0.5)"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <hr>
     <b-row class="justify-content-center">
      <b-col cols="12" lg="6">
        <b-card>
          <SemiCircleProgress
            :rings="progressData"
            :size="400"
            :ringWidth="35"
            :ringGap="12"
            centerTitle="75%"
            centerSubtitle="Progreso Total"
          />
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import BarChart from '@/components/Graficas/BarChart.vue'
import LineChart from '@/components/Graficas/LineChart.vue'
import PieChart from '@/components/Graficas/PieChart.vue'
import DoughnutChart from '@/components/Graficas/DoughnutChart.vue'
import AreaChart from '@/components/Graficas/AreaChart.vue'
import SemiCircleProgress from '@/components/Graficas/SemiCircleProgress2.vue'

export default {
  name: 'DashboardGraficas',
  components: {
    BarChart,
    LineChart,
    PieChart,
    DoughnutChart,
    AreaChart,

    SemiCircleProgress
  },
  data() {
    return {

//medio circulo de barras
      series: [69.2, 11.5, 11.4, 7.9],
      chartOptions: {
        chart: {
          type: 'radialBar'
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            hollow: {
              size: '30%'
            }
          }
        },
        colors: ['#FF6B00', '#775DD0', '#00A86B', '#FEB019'],
        labels: [
          'Nivel 1',
          'Nivel 2',
          'Fundamentos',
          'Eleva'
        ]
      },
//medio circulo de barras



      progressData: [
        { label: 'Videos Completados', value: 85, color: '#6b20c1' },
        { label: 'Actividades Realizadas', value: 70, color: '#ff5e20' },
        { label: 'Exámenes Aprobados', value: 60, color: '#ffc107' }
      ],

    // Datos para área simple
      areaLabels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul'],
      areaData: [65, 59, 80, 81, 56, 55, 70],

      // Datos para múltiples áreas
      multipleAreaDatasets: [
        {
          label: 'Videos completados',
          data: [5, 12, 18, 25, 32, 40],
          borderColor: '#6b20c1',
          backgroundColor: 'rgba(107, 32, 193, 0.2)',
          tension: 0.4
        },
        {
          label: 'Actividades completadas',
          data: [3, 8, 15, 20, 28, 35],
          borderColor: '#ff5e20',
          backgroundColor: 'rgba(255, 94, 32, 0.2)',
          tension: 0.4
        },
        {
          label: 'Exámenes aprobados',
          data: [2, 5, 10, 15, 22, 30],
          borderColor: '#ffc107',
          backgroundColor: 'rgba(255, 193, 7, 0.2)',
          tension: 0.4
        }
      ],

      // Datos para áreas apiladas
      stackedAreaDatasets: [
        {
          label: 'Matemáticas',
          data: [10, 15, 20, 25, 30, 35],
          borderColor: '#6b20c1',
          backgroundColor: 'rgba(107, 32, 193, 0.5)',
          tension: 0.4
        },
        {
          label: 'Ciencias',
          data: [8, 12, 18, 22, 25, 30],
          borderColor: '#ff5e20',
          backgroundColor: 'rgba(255, 94, 32, 0.5)',
          tension: 0.4
        },
        {
          label: 'Historia',
          data: [5, 8, 12, 15, 18, 20],
          borderColor: '#ffc107',
          backgroundColor: 'rgba(255, 193, 7, 0.5)',
          tension: 0.4
        }
      ],


 // Opciones para gráfica apilada
      stackedOptions: {
        scales: {
          y: {
            stacked: true,
            beginAtZero: true
          },
          x: {
            stacked: true
          }
        }
      },

      //datos para dona
  doughnutLabels: ['Completados', 'En Progreso', 'Pendientes'],
      doughnutData: [45, 30, 25],

      //datos para pie
   pieLabels: ['Básico', 'Intermedio', 'Avanzado', 'Experto'],
      pieData: [35, 40, 20, 5],



      
 // Datos para línea simple
      lineLabels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul'],
      lineData: [65, 59, 80, 81, 56, 55, 70],

 // Datos para múltiples líneas
      multipleLinesDatasets: [
        {
          label: 'Videos completados',
          data: [5, 12, 18, 25, 32, 40],
          borderColor: '#6b20c1',
          backgroundColor: 'rgba(107, 32, 193, 0.1)',
          fill: true,
          tension: 0.4
        },
        {
          label: 'Actividades completadas',
          data: [3, 8, 15, 20, 28, 35],
          borderColor: '#ff5e20',
          backgroundColor: 'rgba(255, 94, 32, 0.1)',
          fill: true,
          tension: 0.4
        },
        {
          label: 'Exámenes aprobados',
          data: [2, 5, 10, 15, 22, 30],
          borderColor: '#ffc107',
          backgroundColor: 'rgba(255, 193, 7, 0.1)',
          fill: true,
          tension: 0.4
        }
      ],
      
      // Datos para gráfica de barras simple
      barChartLabels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio'],
      barChartData: [40, 20, 12, 39, 10, 40],
      barChartLabel: 'Ventas',

      // Datos para gráfica de barras múltiples
      multipleBarDatasets: [
        {
          label: 'Ventas 2023',
          data: [30, 15, 10, 35, 8, 35],
          backgroundColor: '#ff5e20'
        },
        {
          label: 'Ventas 2024',
          data: [40, 20, 12, 39, 10, 40],
          backgroundColor: '#6b20c1'
        }
      ],



    }//return
  }
}
</script>